import { IonSpinner } from "@ionic/react";
import { GoogleMap, Marker } from "@react-google-maps/api";
import { useGoogleMapContext } from "@src/app/context/googleMapContext";
import { GoogleMapErrorBoundary } from "@src/appV2/redesign/GeoLocation/GoogleMapErrorBoundary";
import { LA_CENTER } from "@src/lib/deprecatedCode";
import { Location } from "@src/lib/interface";
import { memo, useEffect, useState } from "react";

import iconMarkerCurrentLocation from "../../assets/icons/google-map/markerCurrentLocation.svg";

const googleMapContainerStyle = {
  width: "100%",
  height: "100%",
};

interface AddressViewMapProps {
  location: Location | undefined;
}

function AddressViewMapComponent(props: AddressViewMapProps) {
  const { location } = props;
  const [mapLocation, setMapLocation] = useState(location ?? LA_CENTER);
  const { isMapLoaded } = useGoogleMapContext();

  useEffect(() => {
    if (!location) {
      return;
    }
    setTimeout(() => {
      setMapLocation(location);
    }, 500);
  }, [location]);

  if (!isMapLoaded) {
    return (
      <div style={{ textAlign: "center", marginTop: "10em" }}>
        <IonSpinner color="primary" />
      </div>
    );
  }

  return (
    <GoogleMapErrorBoundary>
      <GoogleMap
        mapContainerStyle={googleMapContainerStyle}
        zoom={17}
        center={mapLocation}
        options={{
          disableDefaultUI: true,
        }}
      >
        {mapLocation && <Marker position={mapLocation} icon={iconMarkerCurrentLocation} />}
      </GoogleMap>
    </GoogleMapErrorBoundary>
  );
}

export const AddressViewMap = memo(AddressViewMapComponent);
